import styled from "styled-components";
import { themes } from "../../Utils/themes";
import { device } from "../../Utils/device";
import { Link } from "react-router-dom";

export const HeaderWrap = styled.header`
  display: block;
  margin: 0;
  padding: 0;
  border: 0;
  width: 100%;
  height: 60px;
  position: fixed;
  color: ${themes.colors.primary};
  background-color: ${themes.colors.white};
  z-index: 9999;
  top: 0;
  @media ${device.desktop} {
    position: relative;
    height: 90px;
    width: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;
  }
`;

export const MenuItem = styled(Link)`
  padding: 10px;
  color: ${themes.colors.text};
  font-size: ${themes.textSize.m1};
  font-weight: bold;
  text-decoration: none;
  border-radius: 20px;
  margin: 10px;
  position: relative;
  white-space: nowrap;
  @media ${device.desktop} {
    color: ${themes.colors.text};
    padding-left: 5px;
    font-size: ${themes.textSize.m2};
  }
  &:after {
    position: absolute;
    left: 0;
    content: "";
    width: 100%;
    height: 2px;
    background: ${themes.colors.primary};
    bottom: -5px;
    transform: scale(0, 1);
    transform-origin: center top; /*変形（アンダーラインの伸長）の原点がaタグ（各メニュー）の右端*/
    transition: transform 0.3s; /*変形の時間*/
  }
  &:hover::after {
    transform: scale(1, 1); /*ホバー後、x軸方向に1（相対値）伸長*/
  }
`;

export const StyledLink = styled.a`
  color: ${themes.colors.primary};
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${themes.colors.filled};
  font-weight: bold;
  border-radius: 8px;
  height: 100%;
  padding: 5px 10px;
  white-space: nowrap;
  font-size: ${themes.textSize.m1};
  @media ${device.desktop} {
    width: 198px;
    height: 46px;
    font-size: ${themes.textSize.m2};
    border-radius: 12px;
    margin-right: 20px;
  }
`;
